import { render, staticRenderFns } from "./channel-sidebar.vue?vue&type=template&id=4d1bff96&scoped=true&lang=pug"
import script from "./channel-sidebar.vue?vue&type=script&lang=js"
export * from "./channel-sidebar.vue?vue&type=script&lang=js"
import style0 from "./channel-sidebar.vue?vue&type=style&index=0&id=4d1bff96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1bff96",
  null
  
)

export default component.exports